import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const Header = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

export const Body = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

export const Footer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

export const Typography = styled(Box)(() => ({
    color: "#1976d2",
}));
